import React from 'react';
import { BoneIcon, FlameIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { offerItems } from '../data/content';
import { CheckItem } from './CheckItem';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type OfferSectionProps = {
  showReferencePrices: boolean;
  guaranteeEnabled: boolean;
};
export function OfferSection({
  guaranteeEnabled
}: OfferSectionProps) {
  return <section id="offer" className="scroll-mt-2 bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-132" data-mp="mejsg5kmk7pc">
      <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-amber-700 md:text-[12px]" data-id="element-133" data-mp="re662g4d7pyo">
        Special launch offer
      </p>

      <div className="mx-auto mt-1.5 max-w-[512px] rounded-lg border-2 border-amber-400 bg-slate-50 px-3 pb-4 pt-3 md:px-4" data-id="element-134" data-mp="wbojaipf0rch">
        <h2 className="text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-blue-950 md:text-[28px]" data-id="element-135" data-mp="2t7dwaklinrzc">
          <BoneIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-teal-700" strokeWidth={2.5} aria-hidden data-id="element-136" data-mp="12nictk7lq9sy" />
          Complete Postoperative Knee Rehabilitation System™
        </h2>
        <p className="mx-auto mt-1 max-w-[420px] text-[11px] font-bold uppercase leading-[1.35] text-teal-700 md:text-[12px]" data-id="element-137" data-mp="xuyxoit9n6m1">
          The complete postoperative knee rehabilitation collection for physical therapy professionals.
        </p>

        <div className="mx-auto mt-2.5 max-w-[220px]" data-id="element-138" data-mp="1llbeykaeifpa">
          <ProductImage data-id="element-139" data-mp="1lk08udthgvv0" />
        </div>

        <p className="mt-2 text-[13px] font-extrabold uppercase text-blue-950 md:text-[14px]" data-id="element-140" data-mp="1gn1fvylk2uye">
          7 Advanced Clinical Volumes + 5 FREE Professional Bonuses
        </p>
        <p className="mt-0.5 text-[13px] text-slate-600 md:text-[14px]" data-id="element-141" data-mp="17mv7us8mmn6m">Your purchase includes:</p>
        <ul className="mx-auto mt-1.5 max-w-[400px] text-left text-[14px] leading-[1.5] text-slate-600 md:text-[15px]" data-id="element-142" data-mp="169ij090ws3r">
          {offerItems.map(item => <CheckItem key={item} data-id="element-143" data-mp="3sbizk2f1hw18">{item}</CheckItem>)}
        </ul>
        <p className="mt-2 text-[12px] font-extrabold uppercase text-teal-700 md:text-[13px]" data-id="element-144" data-mp="3tvauc4bu9ed7">
          480 pages across 12 digital resources
        </p>

        <p className="mt-3 flex items-center justify-center gap-1.5 text-[14px] font-extrabold uppercase leading-tight text-blue-950 md:text-[16px]" data-id="element-145" data-mp="3ktl4v41iopi2">
          <FlameIcon className="h-4 w-4 shrink-0 fill-orange-400 text-orange-600" strokeWidth={2} aria-hidden data-id="element-146" data-mp="3otbpsr4d4beo" />
          Get the complete system today!
        </p>
        <p className="mt-1 text-[14px] font-extrabold uppercase text-blue-950" data-id="element-147" data-mp="3fuq971igb6gj">Only</p>
        <p className="text-[46px] font-extrabold leading-none tracking-[-1px] text-amber-500 md:text-[54px]" data-id="element-148" data-mp="315lu3t6ydicn">
          {formatPrice(PRODUCT_PRICE)} <span className="text-[18px] tracking-normal text-blue-950 md:text-[20px]" data-id="element-149" data-mp="3656tu5ty5uqf">USD</span>
        </p>

        <div className="mt-2.5" data-id="element-150" data-mp="2s55r0ku4gd8b">
          <CtaButton mode="checkout" className="max-w-none min-h-[64px]" data-id="element-151" data-mp="2x3qtkqwuj8zx">
            Get instant access
          </CtaButton>
        </div>

        <p className="mx-auto mt-2.5 max-w-[420px] text-[11px] font-bold uppercase leading-snug text-blue-950 md:text-[12px]" data-id="element-152" data-mp="2dj021en6xm5x">
          {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-700" aria-hidden data-id="element-153" data-mp="2min504vkj013" />}
          Digital delivery
          {guaranteeEnabled && <>
              {' '}
              <span className="text-amber-500" data-id="element-154" data-mp="2wg9jiq8ygpkj">•</span> 7-day money-back guarantee
            </>}
        </p>
        <p className="mt-1 text-[12px] font-extrabold uppercase text-teal-700 md:text-[13px]" data-id="element-155" data-mp="2rgoogqwwp1d3">
          7 Professional Volumes + 5 FREE Bonuses
        </p>
      </div>
    </section>;
}